module.exports = __webpack_public_path__ + "static/media/step4.6b38bf9e.png";